import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { HOST } from 'config/config';
import tableDataQueryStringBuilder from 'services/Utilities/TableData';
import useToast from 'services/Hooks/useToast';

export const useToolings = tableDataParam => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['toolings', JSON.stringify(tableDataParam)],
    queryFn: async () => {
      const response = await axios.get(HOST + '/api/dealer-portal/toolings', {
        paramsSerializer: params => tableDataQueryStringBuilder(params),
        params: tableDataParam,
      });
      return response.data;
    },
    staleTime: 0,
    throwOnError: errorMessage,
  });
  return query;
};

export const useTooling = id => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['tooling', id],
    queryFn: async () => {
      const response = await axios.get(HOST + `/api/dealer-portal/toolings/${id}`);
      return response.data;
    },
    placeholderData: id === 'create' ? { id: uuidv4() } : undefined,
    enabled: id !== 'create',
    throwOnError: errorMessage,
  });
  return query;
};

export const useGetToolingPrice = () => {
  const { errorMessage } = useToast();

  const query = useMutation({
    mutationKey: ['addCartTooling'],
    mutationFn: async priceRequestDto => {
      return await axios.get(`${HOST}/api/dealer-portal/toolings/get-price`, {
        paramsSerializer: params => {
          let queryParam = `quantity=${params.quantity}&toolingId=${params.toolingId}`;
          queryParam += params.selectedAdditionalToolings.map((t, i) => `&toolingIds[${i}]=${t}`).join('');

          return queryParam;
        },
        params: priceRequestDto,
      });
    },
    onSuccess: ({ data }) => {},
    onError: errorMessage,
  });
  return query;
};
